import { useEffect, useRef } from 'react';
import { useLocation, useNavigate, useSearchParams } from 'react-router-dom';
import '@/pages/home/home.css';
import SiteNav from '@/components/feature/SiteNav';
import VisitFooter from '@/pages/home/components/VisitFooter';
import { products } from '@/mocks/products';
import { usePickupBag } from '@/hooks/usePickupBag';
import VisitHero from './components/VisitHero';
import VisitDetails from './components/VisitDetails';
import PickupRequest from './components/PickupRequest';

export default function VisitPage() {
  const [params] = useSearchParams();
  const { hash, pathname } = useLocation();
  const navigate = useNavigate();
  const { addItem } = usePickupBag();
  const consumed = useRef(false);
  const rawSlug = params.get('product') ?? '';

  // Legacy entry /visit?product=<slug>&qty=<n>: add once to the bag, then strip the query so refresh can't re-add it.
  useEffect(() => {
    if (!rawSlug || consumed.current) return;
    consumed.current = true;
    if (products.some((p) => p.slug === rawSlug)) {
      const q = parseInt(params.get('qty') ?? '1', 10);
      addItem(rawSlug, Number.isFinite(q) ? q : 1);
    }
    navigate(`${pathname}#pickup`, { replace: true });
  }, [rawSlug, params, addItem, navigate, pathname]);

  useEffect(() => {
    document.title = 'Visit & Pickup — FOLD. Artisan Bakery';
    document.querySelector('meta[name="description"]')?.setAttribute('content', 'Visit FOLD. Artisan Bakery: opening hours, location and a simple pickup request for croissants, pastries and sourdough collected at the counter.');
    if (rawSlug || hash === '#pickup') document.getElementById('pickup')?.scrollIntoView();
    else window.scrollTo(0, 0);
  }, [rawSlug, hash]);

  return (
    <div className="fold-home">
      <SiteNav />
      <main>
        <VisitHero />
        <VisitDetails />
        <PickupRequest />
        <VisitFooter showVisit={false} />
      </main>
    </div>
  );
}